var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1 6.2L15 10.1L11.1 14L10.177 13.077L12.5105 10.75H7.2V9.45H12.5105L10.177 7.123L11.1 6.2ZM5.9 1L6.823 1.923L4.4895 4.25H9.8V5.55H4.4895L6.823 7.877L5.9 8.8L2 4.9L5.9 1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSwitch);
export default __webpack_public_path__ + "static/media/icon_switch.834d11446a398eec6632b63f4aecdeee.svg";
export { ForwardRef as ReactComponent };